/**
 * @module VideoPlayer
 * @return {Object} public methods
 */

const VideoPlayer = (function () {
    var $video;

    function init() {
        if ($('video').length === 0) return false;
        getDOMElements();
        addListeners();
    }

    function getDOMElements() {
        $video = $('video');
    }

    function addListeners() {
        $video.click(onVideoClick);
        $video.bind('play', onPlayVideo);
        $video.bind('pause', onPauseVideo);
        $('.product-gallery__slider').on('afterChange', onAfterSliderChange);
    }

    /**
     * When using html 5 make video div clickable and start/stop video.
     * @param {MouseEvent} e
     */
    function onVideoClick(e) {
        var video = e.target;

        if (video.paused){
            video.play();
        } else {
            video.pause();
        }
    }

    function onPlayVideo() {
        $('button.slick-prev, button.slick-next').velocity('fadeOut', {duration: 500});
    }

    function onPauseVideo() {
        $('button.slick-prev, button.slick-next').velocity('fadeIn', {duration: 500});
    }

    /**
     * Ugly fix... prevents black video screen in product gallery!
     */
    function onAfterSliderChange() {
        $video.children('div').css('margin-top', '1px');
    }

    function toggleFullScreen() {
        if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement ) {  // current working methods
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.msRequestFullscreen) {
                document.documentElement.msRequestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        }
    }

    // Return public methods
    return {
        init: init
    };
})();

window.VideoPlayer = VideoPlayer;
export default VideoPlayer;
